import React from "react";
import { isEmpty } from "lodash";
import { useOutletContext } from "react-router-dom";
// component
import RMDRImage from "@/components/RMDRImage";
import AnimatedWave01 from "@/components/shapes/AnimatedWave01";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import RMDRLink from "@/components/RMDRLink";
// types
import { TMainPageLayoutV2 } from "../type";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TOutletContext from "@/cms/types/TOutletContext";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion, 
    metaDataLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import EContentType from "@/cms/enums/EContentType";


const RenderItems = (props:{ payload?:TClientMainPageItemList[]|null, languageVersionSelector:any }) => {
    console.log("MNPG024.RenderItems", props);

    const { siteSettingPayload } = useOutletContext<TOutletContext>();

    const careProgramVarString01 = metaDataLanguageVersion("careProgramVarString01", siteSettingPayload.languageVersions);
    const careProgramVarString02 = metaDataLanguageVersion("careProgramVarString02", siteSettingPayload.languageVersions);
    const careProgramVarString03 = metaDataLanguageVersion("careProgramVarString03", siteSettingPayload.languageVersions);

    if ( !isEmpty(props.payload) && props.payload ) {
        return (
            <>
                {
                    props.payload?.map((item, index) => {
                        const itemLanguageVersion:TLanguageVersionList = props.languageVersionSelector(item.languageVersions);

                        const careProgramVar01 = metaDataLanguageVersion("careProgramVar01", item.languageVersions);
                        const careProgramVar02 = metaDataLanguageVersion("careProgramVar02", item.languageVersions);
                        const careProgramVar03 = metaDataLanguageVersion("careProgramVar03", item.languageVersions);

                        return (
                            <div className="col-xl-4 col-lg-6 col-md-6" data-aos-duration="800" data-aos="fade-up" data-aos-delay={`${300+(index*200)}`}>
                                <div className="clases-items">
                                    <div className="clases-bg"></div>
                                    <div className="clases-image">
                                        <RMDRImage 
                                            resources={item?.resources}
                                            resourceType={EResourceType.OUTER_IMAGE}
                                            alt={itemLanguageVersion?.name}
                                            title={itemLanguageVersion?.name}
                                        />
                                    </div>
                                    <div className="clases-content">
                                        <h4>
                                            <RMDRLink 
                                                text={itemLanguageVersion?.name}
                                                title={itemLanguageVersion?.name}
                                                navigationURL={itemLanguageVersion?.contentRouteNavigationURL}
                                                hasNavigationDestination={item.hasDestinationNavigation}
                                                redirectType={item.redirectType}
                                                isShowAlways
                                                variant="span"
                                            />
                                        </h4>
                                         <p>
                                            <RMDRComponentSanitizer 
                                                languageVersion={itemLanguageVersion}
                                                variant="span"
                                                valueExpr="value"
                                                className="tw-line-clamp-6"
                                                removeTag
                                            />
                                        </p>
                                        {/* <ul className="clases-schedule">
                                            <li>
                                                <span>{careProgramVarString01}</span><br />{careProgramVar01}
                                            </li>
                                            <li>
                                                <span>{careProgramVarString02}</span><br />{careProgramVar02}
                                            </li>
                                            <li>
                                                <span>{careProgramVarString03}</span><br />{careProgramVar03}
                                            </li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    return null;

}

const Render = ( props:TMainPageLayoutV2 ) => {
    console.log("MNPG024.Render", props);

    const childs = props.templates?.filter((item) => item.mapLayoutName === props.template?.mapLayoutName && ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
    
    if ( !childs || isEmpty(childs) ) return null;
    return (<RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} />)
    
}

const MNPG024 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG024.rendered", props);

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions);

    return (
        <section
            id="clases"    
            className="section section-style-01 section-padding bg-cover event-bg-img"
        >
            <AnimatedWave01 />
            <div className="container">
                <div className="section-title text-center">
                    <RMDRComponentSanitizer 
                        languageVersion={languageVersion} 
                        className="text-white" 
                        valueExpr="name" 
                        variant="h2" 
                        extraData={{
                            "data-aos-duration": "800",
                            "data-aos": "fade-up",
                            "data-aos-delay": "300"
                        }}
                    />
                </div>
                <div className="row">
                    <Render {...props} />
                </div>
            </div>
        </section>
    )
}

const Component = React.memo(MNPG024, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG024.memo", { prevProps, nextProps });
    return true;
});

export default Component;
